import React from 'react'
import { useHistory } from 'react-router-dom'

import SidePopup from '../../../components/SidePopup'

import PlanPriceSelector from 'components/Form/PlanPriceSelector'


function PlanEditPopup(props) {
  const history = useHistory()

  const hideModal = (e) => {
    if (e) e.preventDefault()
    history.goBack()
  }

  const onCallback = (error, isOk) => {
    if (isOk) hideModal()
  }

  return (
    <SidePopup onHide={hideModal}>
      <PlanPriceSelector
        onChange={onCallback}
      />
    </SidePopup>
  )
}

export default PlanEditPopup
